import { memo } from 'react';
import { Stack } from '@mui/material';
import StepContent from '@/views/add-product/components/step-content';
import { ProductDetailsSection } from './components/ProductDetailsSection';
import { UnitProductsSection } from './components/UnitProductsSection';
import { PricingFinancialSection } from './components/PricingFinancialSection';
import { AssetsSection } from './components/AssetsSection';

export type PreviewStepProps = {
    errors: string[];
};

const PackagePreviewStep = ({ errors }: PreviewStepProps) => {
    return (
        <StepContent title="Preview" errors={errors}>
            <Stack spacing={3}>
                <ProductDetailsSection />
                <UnitProductsSection />
                <PricingFinancialSection />
                <AssetsSection />
            </Stack>
        </StepContent>
    );
};

export default memo(PackagePreviewStep);
